import { takeEvery, put, select } from 'redux-saga/effects';
import { 
  afterSavePostAcqUWNavigate,
  setPostAcqTransientValuation
} from 'store/actions';
import { selectedPostAcqValuationSelector } from 'store/selectors';

export function* afterSavePostAcqUWNavigateSaga() {
  yield takeEvery(afterSavePostAcqUWNavigate, function* ({ payload }) {
    if (payload.resetTransient) {
      const selectedValuation = yield select(selectedPostAcqValuationSelector);
      yield put(setPostAcqTransientValuation(selectedValuation));
    }
    navigate(payload)
  });
}

function navigate(payload) {
  const { history, route } = payload
  history.push(route);
};